import "../../chunk-7QVYU63E.js";
const ALCHEMY_USE_INTEGRATION_HEADER = "x-alchemy-use-integration";
const ALCHEMY_USE_INTEGRATION_HEADER_VALUE = "true";
export {
  ALCHEMY_USE_INTEGRATION_HEADER,
  ALCHEMY_USE_INTEGRATION_HEADER_VALUE
};
//# sourceMappingURL=headers.js.map